


















import { Prop, Component, Vue } from 'vue-property-decorator';
import { BillInput } from '@/types/graphql/schemaTypes';
import { billService } from '@/services/BillService';

@Component
export default class Preview extends Vue {
  @Prop() private bill!: BillInput;

  private loading = false;

  private refresh() {
    if (!this.loading) {
      this.loading = true;
      this.$store.dispatch('Alert/addAlert', {
        type: 'info',
        message: this.$t('bills.refresh-message'),
        time: 3000
      });
      billService.regenerateBill(this.bill!.id!).then(() => {
        this.loading = false;
        this.$emit('refresh');
      });
    }
  }
}
